/**
 * AttachmentContent - 附件内容渲染组件
 */

import React from 'react';
import { Paperclip, Download } from '@icon-park/react';

export default function AttachmentContent({ data }) {
  if (!data || !data.attachments || data.attachments.length === 0) return null;

  const handleDownload = (attachment, e) => {
    if (attachment.file?.url) {
      e.preventDefault();
      // 打开文件URL（如果是完整URL）或下载
      window.open(attachment.file.url, '_blank');
    }
  };

  const layout = data.layout || 'list';
  const cs = data.cardStyle || {};
  const cardStyle = {
    background: cs.bgColor || (layout === 'card' ? '#f8f9fa' : 'transparent'),
    borderRadius: (cs.radius ?? (layout === 'card' ? 8 : 0)) + 'px',
    border: cs.borderWidth ? `${cs.borderWidth}px solid ${cs.borderColor || '#e8eaed'}` : (layout === 'card' ? '1px solid #e8eaed' : 'none'),
    boxShadow: cs.shadow ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
    color: cs.textColor || '#202124',
    padding: (cs.padding ?? (layout === 'card' ? 12 : 8)) + 'px'
  };

  return (
    <div className="label-content-attachments">
      {data.attachments.map((att, idx) => (
        <div key={idx} className="attachment-item" style={cardStyle}>
          <Paperclip theme="outline" size={16} fill="#5f6368" strokeWidth={3} />
          {att.file?.url ? (
            <a 
              href={att.file.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="attachment-name attachment-link"
              onClick={(e) => handleDownload(att, e)}
              style={{ color: cardStyle.color }}
            >
              {att.name}
              <Download theme="outline" size={14} fill="#1890ff" strokeWidth={3} style={{ marginLeft: '4px' }} />
            </a>
          ) : (
            <span className="attachment-name" style={{ color: cardStyle.color }}>{att.name}</span>
          )}
        </div>
      ))}
    </div>
  );
}
